import {fetchBody, URL_GET_SYSTEM_ACCOUNTLIST, URL_GET_SYSTEM_ACCOUNTDETAIL, URL_UPDATE_SYSTEM_ACCOUNT, URL_CHECK_SYSTEM_ACCOUNT, URL_ADD_SYSTEM_ACCOUNT, URL_GET_CASEOWNER_LIST} from "../config"
import { toLogout, cleanFetch } from "./apiTools";
import { getToken } from "../component/Login/Auth";

//系統帳號

/**
 * 
 * @param {ReqResumeList} mReqResumeList 
 */
export function api_getSystemAccountList ({mReqSystemAccountList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqSystemAccountList, token}), 
      url: URL_GET_SYSTEM_ACCOUNTLIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_checkSystemAccount ({mReqCheckSystemAccount, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqCheckSystemAccount, token}), 
      url: URL_CHECK_SYSTEM_ACCOUNT  , 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}
export function api_addSystemAccount ({mReqAddSystemAccount, accountRoles, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: {mReqAddSystemAccount, accountRoles}, token}), 
      url: URL_ADD_SYSTEM_ACCOUNT, 
      success:(jsonDate)=>{
        success(jsonDate)
        return jsonDate
      },
      failure:(error)=>{
        failure(error)
        return error
      }
    })
  }
}

export function api_getSystemAccountDetail ({accountId, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: {accountId}, token}), 
      url: URL_GET_SYSTEM_ACCOUNTDETAIL, 
      success:(jsonDate)=>{
        success(jsonDate)
        return jsonDate
      },
      failure:(error)=>{
        failure(error)
        return error
      }
    })
  }
}

export function api_updateSystemAccount({mReqUpdateSystemAccount, success, failure}){
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqUpdateSystemAccount, token}), 
      url: URL_UPDATE_SYSTEM_ACCOUNT, 
      success:(jsonDate)=>{
        success(jsonDate)
        return jsonDate
      },
      failure:(error)=>{
        failure(error)
        return error
      }
    })
  }
}

export function api_getCaseOwnerList ({caseOwner, name, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: {caseOwner, name}, token}), 
      url: URL_GET_CASEOWNER_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}